/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */
import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  LoginRequest,
  LoginResponse,
  PasswordChangeRequest,
  RegisterResponseDTO,
  UserDto,
} from ".././model";

import { customInstance } from "../../lib/api-client";

/**
 * @summary Login
 */
export const postAuthLogin = (
  loginRequest: LoginRequest,
  signal?: AbortSignal,
) => {
  return customInstance<LoginResponse>({
    url: `/auth/login`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: loginRequest,
    signal,
  });
};

export const getPostAuthLoginMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAuthLogin>>,
    TError,
    { data: LoginRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAuthLogin>>,
  TError,
  { data: LoginRequest },
  TContext
> => {
  const mutationKey = ["postAuthLogin"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAuthLogin>>,
    { data: LoginRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postAuthLogin(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAuthLoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAuthLogin>>
>;
export type PostAuthLoginMutationBody = LoginRequest;
export type PostAuthLoginMutationError = void;

/**
 * @summary Login
 */
export const usePostAuthLogin = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAuthLogin>>,
      TError,
      { data: LoginRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAuthLogin>>,
  TError,
  { data: LoginRequest },
  TContext
> => {
  const mutationOptions = getPostAuthLoginMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Logout
 */
export const getAuthLogout = (signal?: AbortSignal) => {
  return customInstance<boolean>({
    url: `/auth/logout`,
    method: "GET",
    signal,
  });
};

export const getGetAuthLogoutInfiniteQueryKey = () => {
  return ["infinite", `/auth/logout`] as const;
};

export const getGetAuthLogoutQueryKey = () => {
  return [`/auth/logout`] as const;
};

export const getGetAuthLogoutInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getAuthLogout>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getAuthLogout>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAuthLogoutInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuthLogout>>> = ({
    signal,
  }) => getAuthLogout(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getAuthLogout>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAuthLogoutInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAuthLogout>>
>;
export type GetAuthLogoutInfiniteQueryError = unknown;

export function useGetAuthLogoutInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAuthLogout>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAuthLogout>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthLogout>>,
          TError,
          Awaited<ReturnType<typeof getAuthLogout>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAuthLogoutInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAuthLogout>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAuthLogout>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthLogout>>,
          TError,
          Awaited<ReturnType<typeof getAuthLogout>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAuthLogoutInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAuthLogout>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAuthLogout>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Logout
 */

export function useGetAuthLogoutInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAuthLogout>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAuthLogout>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAuthLogoutInfiniteQueryOptions(options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetAuthLogoutQueryOptions = <
  TData = Awaited<ReturnType<typeof getAuthLogout>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getAuthLogout>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAuthLogoutQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuthLogout>>> = ({
    signal,
  }) => getAuthLogout(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAuthLogout>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAuthLogoutQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAuthLogout>>
>;
export type GetAuthLogoutQueryError = unknown;

export function useGetAuthLogout<
  TData = Awaited<ReturnType<typeof getAuthLogout>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAuthLogout>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthLogout>>,
          TError,
          Awaited<ReturnType<typeof getAuthLogout>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAuthLogout<
  TData = Awaited<ReturnType<typeof getAuthLogout>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAuthLogout>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthLogout>>,
          TError,
          Awaited<ReturnType<typeof getAuthLogout>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAuthLogout<
  TData = Awaited<ReturnType<typeof getAuthLogout>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAuthLogout>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Logout
 */

export function useGetAuthLogout<
  TData = Awaited<ReturnType<typeof getAuthLogout>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAuthLogout>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAuthLogoutQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Register
 */
export const postAuthRegister = (userDto: UserDto, signal?: AbortSignal) => {
  return customInstance<RegisterResponseDTO>({
    url: `/auth/register`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: userDto,
    signal,
  });
};

export const getPostAuthRegisterMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAuthRegister>>,
    TError,
    { data: UserDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAuthRegister>>,
  TError,
  { data: UserDto },
  TContext
> => {
  const mutationKey = ["postAuthRegister"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAuthRegister>>,
    { data: UserDto }
  > = (props) => {
    const { data } = props ?? {};

    return postAuthRegister(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAuthRegisterMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAuthRegister>>
>;
export type PostAuthRegisterMutationBody = UserDto;
export type PostAuthRegisterMutationError = void;

/**
 * @summary Register
 */
export const usePostAuthRegister = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAuthRegister>>,
      TError,
      { data: UserDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAuthRegister>>,
  TError,
  { data: UserDto },
  TContext
> => {
  const mutationOptions = getPostAuthRegisterMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update User Data
 */
export const putAuthUser = (userDto: UserDto) => {
  return customInstance<UserDto>({
    url: `/auth/user`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: userDto,
  });
};

export const getPutAuthUserMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putAuthUser>>,
    TError,
    { data: UserDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putAuthUser>>,
  TError,
  { data: UserDto },
  TContext
> => {
  const mutationKey = ["putAuthUser"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putAuthUser>>,
    { data: UserDto }
  > = (props) => {
    const { data } = props ?? {};

    return putAuthUser(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutAuthUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof putAuthUser>>
>;
export type PutAuthUserMutationBody = UserDto;
export type PutAuthUserMutationError = void;

/**
 * @summary Update User Data
 */
export const usePutAuthUser = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putAuthUser>>,
      TError,
      { data: UserDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putAuthUser>>,
  TError,
  { data: UserDto },
  TContext
> => {
  const mutationOptions = getPutAuthUserMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get User Data
 */
export const getAuthUser = (signal?: AbortSignal) => {
  return customInstance<UserDto>({ url: `/auth/user`, method: "GET", signal });
};

export const getGetAuthUserInfiniteQueryKey = () => {
  return ["infinite", `/auth/user`] as const;
};

export const getGetAuthUserQueryKey = () => {
  return [`/auth/user`] as const;
};

export const getGetAuthUserInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getAuthUser>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getAuthUser>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAuthUserInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuthUser>>> = ({
    signal,
  }) => getAuthUser(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getAuthUser>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAuthUserInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAuthUser>>
>;
export type GetAuthUserInfiniteQueryError = void;

export function useGetAuthUserInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAuthUser>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAuthUser>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthUser>>,
          TError,
          Awaited<ReturnType<typeof getAuthUser>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAuthUserInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAuthUser>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAuthUser>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthUser>>,
          TError,
          Awaited<ReturnType<typeof getAuthUser>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAuthUserInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAuthUser>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAuthUser>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get User Data
 */

export function useGetAuthUserInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAuthUser>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAuthUser>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAuthUserInfiniteQueryOptions(options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetAuthUserQueryOptions = <
  TData = Awaited<ReturnType<typeof getAuthUser>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getAuthUser>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAuthUserQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuthUser>>> = ({
    signal,
  }) => getAuthUser(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAuthUser>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAuthUserQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAuthUser>>
>;
export type GetAuthUserQueryError = void;

export function useGetAuthUser<
  TData = Awaited<ReturnType<typeof getAuthUser>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAuthUser>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthUser>>,
          TError,
          Awaited<ReturnType<typeof getAuthUser>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAuthUser<
  TData = Awaited<ReturnType<typeof getAuthUser>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAuthUser>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthUser>>,
          TError,
          Awaited<ReturnType<typeof getAuthUser>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAuthUser<
  TData = Awaited<ReturnType<typeof getAuthUser>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAuthUser>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get User Data
 */

export function useGetAuthUser<
  TData = Awaited<ReturnType<typeof getAuthUser>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAuthUser>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAuthUserQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Change Password
 */
export const postAuthUserPassword = (
  passwordChangeRequest: PasswordChangeRequest,
  signal?: AbortSignal,
) => {
  return customInstance<boolean>({
    url: `/auth/user/password`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: passwordChangeRequest,
    signal,
  });
};

export const getPostAuthUserPasswordMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAuthUserPassword>>,
    TError,
    { data: PasswordChangeRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAuthUserPassword>>,
  TError,
  { data: PasswordChangeRequest },
  TContext
> => {
  const mutationKey = ["postAuthUserPassword"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAuthUserPassword>>,
    { data: PasswordChangeRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postAuthUserPassword(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAuthUserPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAuthUserPassword>>
>;
export type PostAuthUserPasswordMutationBody = PasswordChangeRequest;
export type PostAuthUserPasswordMutationError = void;

/**
 * @summary Change Password
 */
export const usePostAuthUserPassword = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAuthUserPassword>>,
      TError,
      { data: PasswordChangeRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAuthUserPassword>>,
  TError,
  { data: PasswordChangeRequest },
  TContext
> => {
  const mutationOptions = getPostAuthUserPasswordMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
